export default class TweensPlacer
{
    constructor(scene)
    {
        this.scene = scene;
    }

    TweenInTray(Tabs,Tray)
    {
        this.scene.playSound("drawer_open_close");
        for (let x in Tabs)
        {
            this.scene.addTween(Tabs[x], 800, {x:{start: Tabs[x].x - 100, to: Tabs[x].x}}, Phaser.Math.Easing.Quadratic.InOut);
        }
        this.scene.addTween(Tray, 800, {x:{start: Tray.x - Tray.width, to: Tray.x}}, Phaser.Math.Easing.Quadratic.InOut);
    }

    TweenInCake(Cake,Plate)
    {
        this.scene.addTween(Cake, 800, {x:{start: this.scene.mid.x, to: Cake.x}}, Phaser.Math.Easing.Quadratic.InOut);
        this.scene.addTween(Plate, 800, {x:{start: this.scene.mid.x, to: Plate.x}}, Phaser.Math.Easing.Quadratic.InOut);
    }

    TweenItemToTray(Temp,Original = 'null')
    {
        if (Original === "null")
        {
            //console.log("Called it");
            var ToX;
            var ToY;
            
            if (this.scene.Active.getData('TabName') === Temp.getData('TabName'))
            {
                ToX = Temp.getData('TrayX');
                ToY = Temp.getData('TrayY');
            }
            else
            {
                ToX = Temp.getData('TabX');
                ToY = Temp.getData('TabY');
            }
        }
        else
        {
            ToX = Original.x;
            ToY = Original.y;
        }
        let Tween = this.scene.addTween(Temp,400,{alpha:0.1, x: ToX, y: ToY});
            Tween.once('complete',()=>
            {
                Temp.destroy();
            });
    }

    TweenOutTab(Tab,Group,Tray)
    {
        this.scene.playSound("drawer_open_close");
        let TabMove = this.scene.addTween(Tray, 492, {x: Tray.x - 246},Phaser.Math.Easing.Quadratic.InOut);
        this.scene.addTween(Tab,60,{x: Tab.x - 30, delay: 432}, Phaser.Math.Easing.Linear.InOut);
        
        Group.getChildren().forEach((Child)=>
        {
            this.scene.addTween(Child, 492, {x: Child.x - 246},Phaser.Math.Easing.Quadratic.InOut);
        });
        
        TabMove.once('complete',()=>
        {
            Group.clear(true,true);
        });
    }

    TweenInTab(Tab, Group, Tray)
    {
        this.scene.addTween(Tray, 492, {x: Tray.x + 246},Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(Tab,60,{x: Tab.x + 30, delay: 120}, Phaser.Math.Easing.Linear.InOut);

        Group.getChildren().forEach((Child)=>
        {
            this.scene.addTween(Child, 492, {x: Child.x + 246},Phaser.Math.Easing.Quadratic.Out);
        });
    }

    CandleFireIdleTween(Fire)
    {
        var FlameScale = Fire.scale;

        //this.addTween(ToTween, 100, {y: ToTween.y + 4, yoyo:true, loop: -1, delay: RandomTimeFlame}, Phaser.Math.Easing.Quadratic.In);
        //this.addTween(ToTween, 50, {rotation: {start: ToTween.rotation, from: ToTween.rotation+.09, to: ToTween.rotation-.1}, yoyo:true, loop: -1, delay: RandomTimeFlameRotate}, Phaser.Math.Easing.Quadratic.In);

        var Flamen = this.scene.addTween(Fire, 100, {scaleY:FlameScale + .14, yoyo: true},Phaser.Math.Easing.Bounce.Quadratic,()=>{
            switch(Math.floor(Math.random()*3))
            {
                case 0:
                    this.scene.addTween(Fire, 100, {scaleY:FlameScale + .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                        break;
                case 1:
                    this.scene.addTween(Fire, 60, {scaleY:FlameScale - .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                    break;
                case 2:
                    this.scene.addTween(Fire, 50, {scaleY:FlameScale + .05, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                    break;
            }
        });
    }

    TweenOutTrayPrint(Tabs, Group, Tray)
    {
        for (let x in Tabs)
        {
            this.scene.addTween(Tabs[x], 800, {x:Tabs[x].x - 130}, Phaser.Math.Easing.Quadratic.InOut);
        }
        let Tween = this.scene.addTween(Tray, 800, {x:Tray.x - Tray.width}, Phaser.Math.Easing.Quadratic.InOut);
        Group.getChildren().forEach((Child)=>
        {
            this.scene.addTween(Child, 800, {x:Child.x - Tray.width}, Phaser.Math.Easing.Quadratic.InOut);
        });

        return Tween;
    }

    TweenInTrayPrint(Tabs, Group, Tray)
    {
        for (let x in Tabs)
        {
            this.scene.addTween(Tabs[x], 800, {x:Tabs[x].x + 130}, Phaser.Math.Easing.Quadratic.InOut);
        }
        this.scene.addTween(Tray, 800, {x:Tray.x + Tray.width}, Phaser.Math.Easing.Quadratic.InOut);
        Group.getChildren().forEach((Child)=>
        {
            this.scene.addTween(Child, 800, {x:Child.x + Tray.width}, Phaser.Math.Easing.Quadratic.InOut);
        });
    }

    TweenInButtons(object,TimeTaken,Ease = Phaser.Math.Easing.Linear,OffLeft = true)
    {
        var Rotation;
        var Distance;

        for(let x in object)
        {
            if (x != 3)
            {
                Distance = 6.283 * object[x].width/2;
                Rotation = Distance/(object[x].width/2);

                if (OffLeft != true)
                {
                    Distance = Distance * -1;
                }
                else
                {
                    Rotation = Rotation * -1;
                }

                this.scene.addTween(object[x],TimeTaken,{rotation: Rotation, x: {start:object[x].x + Distance, to: object[x].x}},Ease);
            }
            else
            {
                this.scene.addTween(object[x], TimeTaken+100,{x:{start: object[x].x + 200, to:object[x].x}},Phaser.Math.Easing.Bounce.Out);
            }
        }
    }

    TweenOutButtons(object,TimeTaken,Ease = Phaser.Math.Easing.Linear,OffLeft = true)
    {
        var Rotation;
        var Distance;
        let DoneButton = 200;

        for(let x in object)
        {
            if (x != 3)
                {
                Distance = 6.283 * object[x].width/2;
                Rotation = Distance/(object[x].width/2);

                if (OffLeft != true)
                {
                    Distance = Distance * -1;
                    Rotation = Rotation * -1;
                    DoneButton = -200;
                }
                else
                {
                    //Rotation = Rotation * -1;
                }

                this.scene.addTween(object[x],TimeTaken,{rotation: Rotation, x: object[x].x + Distance},Ease);
            }
            else
            {
                this.scene.addTween(object[x], TimeTaken+100,{x: object[x].x+DoneButton},Phaser.Math.Easing.Bounce.Out);
            }
        }
    }

    TweenToCakeColorScreen(Group)
    {
        const Distance = 800;
        const Time = 900;
        var ReturnTween;
        Group.getChildren().forEach((Child,Num)=>
        {
            if (Num === 0)
            {
                ReturnTween = this.scene.addTween(Child, Time, {x:Child.x + Distance}, Phaser.Math.Easing.Quadratic.InOut);
            }
            else
            {
                this.scene.addTween(Child, Time, {x:Child.x + Distance}, Phaser.Math.Easing.Quadratic.InOut);
            }

            Child.disableInteractive();
        });
        return ReturnTween;
    }

    TweenOutForPrintSave(Group,Shader)
    {
        const Distance = 170.5;
        //let rect = new Phaser.Geom.Rectangle(0, 0, this.scene.mid.x*2, this.scene.mid.y*2);
        //let shader = this.scene.add.graphics({ fillStyle: { color: 0xFFFFFF } });
        //shader.fillRectShape(rect);
        //shader.setDepth(this.scene.DepthList.Table);
        //shader.alpha = 0;
        Group.getChildren().forEach((Child)=>
        {
            Child.disableInteractive();
            this.scene.addTween(Child, 800, {x:Child.x - Distance}, Phaser.Math.Easing.Quadratic.InOut);
        });
        this.scene.addTween(Shader, 800, {alpha:1}, Phaser.Math.Easing.Linear); 
    }

    TweenInForPrintSave(Group,Shader)
    {
        const Distance = 170.5;

        Group.getChildren().forEach((Child)=>
        {
            if (Child.data != 'null')Child.setInteractive();
            this.scene.addTween(Child, 800, {x:Child.x + Distance}, Phaser.Math.Easing.Quadratic.InOut);
        });
        this.scene.addTween(Shader, 800, {alpha:0}, Phaser.Math.Easing.Linear);
    }

    PrintResizeIn(Top,OverImage,Bottom)
    {
        const Time = 300;
        this.scene.addTween(Top,Time,{y:{start:Top.y - 111,to: Top.y}},Phaser.Math.Easing.Quadratic.InOut);
        this.scene.addTween(Bottom,Time,{y:{start:Bottom.y + 100,to: Bottom.y}},Phaser.Math.Easing.Quadratic.InOut);
        let Tween = this.scene.addTween(OverImage,Time,{scale:.80,y:OverImage.y + 40},Phaser.Math.Easing.Quadratic.InOut);
        return Tween;
    }

    PrintResizeOut(Top,OverImage,Bottom)
    {
        const Time = 300;
        this.scene.addTween(Top,Time,{y:Top.y - 111},Phaser.Math.Easing.Quadratic.InOut);
        this.scene.addTween(Bottom,Time,{y:Bottom.y + 100},Phaser.Math.Easing.Quadratic.InOut);
        let Tween = this.scene.addTween(OverImage,Time,{scale:1,y:OverImage.y - 40},Phaser.Math.Easing.Quadratic.InOut,()=>
        {
            Top.destroy();
            Bottom.destroy();
            OverImage.destroy();
        });
        return Tween;
    }
}